// fx.ns("shared.board", class SingleArea extends fx.Component {
fx.ns("shared.stage", class SingleArea extends shared.stage.Area {
    
	constructor(page, model /*book*/, parentContainer, side)
	{
    super(page, model, parentContainer);

    this._side = side;
  }

  /***************** Overrides *****************/

  load()
  {
    if (this.stage.loaded)
      return;

    this.stage.load();
    this.addClass("loaded");
  }

  create()
  {
    this.stage = new shared.stage.StageSingle(this.page, this.model, this.parentContainer.componentFactory, this.displayedSide);
    this.addChild(this.stage, {top:0, left:0, height:this.height(), width:this.width()});

    if (this.page.isCover)
    {
        this.binding = new shared.stage.CoverBinding( this.creation, this.page );
        this.binding.visibleAtStart = (this.creation.isSpiral || this.creation.isBind);
        this.addChild(this.binding, {left:this.creation.pageWidth, top:0, width: this.creation.sliceWidth, height:"100%"});
    }
  }

  onDataEvent(event)
  {
      super.onDataEvent(event);
      
      switch(event.type)
      {

        case "cover-updated" :
                if (this.binding)
                {
                  this.binding.width(this.creation.sliceWidth);
                  this.binding.toggle(this.creation.isSpiral || this.creation.isBind)
                }
          break;

      }
  }


});